import { select, put, call, all } from 'redux-saga/effects';
import { getMsrpPricingFromAutobahn } from '../../api/eleanorApi';
import { updateProductInfo } from '../../actions/pricingActions';
import { configSelector, productDetailsSelector } from '../../selectors';
import getThdProductDetailsOrNotItsCool from './_getThdProductDetailsOrNotItsCool';
import { getSelectedChoices, getPriceData } from './_utils';

const getOptionType = (parentOptionType, tags) => {
  if (tags.includes('custom-size-width')) {
    return 'Width';
  }

  if (tags.includes('custom-size-height')) {
    return 'Height';
  }

  return parentOptionType;
};
function* getMsrpPricing(skuMap, storeNumber, options, choices) {
  const { config } = yield select();
  const { productId, siteId, partnerProductId } = yield select(configSelector);
  const { productLineId } = yield select(productDetailsSelector);

  const data = {
    siteId,
    productId,
    partnerProductId,
    productLineId,
    choices: getSelectedChoices(options, choices).map((selectedChoice) => ({
      optionId: selectedChoice.optionId,
      choiceId: selectedChoice.id,
      choiceValue: selectedChoice.value,
      tags: selectedChoice.tags,
      optionType: getOptionType(selectedChoice.parentOptionType, selectedChoice.tags),
    })),
  };

  const [pricing, thdDetails] = yield all([
    call(getMsrpPricingFromAutobahn, data),
    call(getThdProductDetailsOrNotItsCool, [partnerProductId], storeNumber, config),
  ]);
  const newSkus = {
    ...skuMap,
    sku: partnerProductId.toString(),
  };

  yield put(updateProductInfo({ newSkus, thdDetails }));

  return getPriceData(pricing.originalPrice, pricing.realPrice);
}

export default getMsrpPricing;
